"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.PlacerRow = void 0;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _Rule = require("./Rule");
var PlacerRow = /*#__PURE__*/function () {
  function PlacerRow(json) {
    (0, _classCallCheck2["default"])(this, PlacerRow);
    this.catalog = null;
    this.model = null;
    this.cmodel = null;
    this.neutro = null;
    this.cod = null;
    this.reg = null;
    this.variants = null;
    this.rule = null;
    if (json) {
      this.catalog = json.catalog || json.catalogo || null;
      this.model = json.model || null;
      this.neutro = json.neutro || null;
      this.reg = json.reg || null;
      this.variants = json.variants || null;
      this.cmodel = this.model;
      this.cod = this.model + this.neutro;
      this.checkFields(json);
    }
  }
  (0, _createClass2["default"])(PlacerRow, [{
    key: "checkFields",
    value: function checkFields(json) {
      var _context,
        _this = this;
      (0, _map["default"])(_context = (0, _keys["default"])(json)).call(_context, function (key) {
        if (!_this.hasOwnProperty(key)) console.warn('%c' + key + '%c is ignored in PlacerRow class', 'color: blue', 'color: inherit');
      });
    }
  }, {
    key: "setRule",
    value: function setRule(rule) {
      if (!(rule instanceof _Rule.Rule)) throw 'rule is not a instance of Rule';
      this.rule = rule;
      this.reg = rule.reg;
    }
  }, {
    key: "mergeJson",
    value: function mergeJson(json) {
      if (json) {
        for (var k in json) {
          if (this.hasOwnProperty(k)) {
            this[k] = json[k];
          }
        }
      }
    }
  }]);
  return PlacerRow;
}();
exports.PlacerRow = PlacerRow;
//# sourceMappingURL=PlacerRow.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/classes/PlacerRow.js
// module id = 476
// module chunks = 142